import { render, staticRenderFns } from "./WorkOrderComment.vue?vue&type=template&id=2046b9ab&scoped=true&"
import script from "./WorkOrderComment.vue?vue&type=script&lang=js&"
export * from "./WorkOrderComment.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderComment.vue?vue&type=style&index=0&id=2046b9ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2046b9ab",
  null
  
)

export default component.exports